/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable import/order */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable eqeqeq */
/* eslint-disable no-return-assign */
/* eslint-disable object-shorthand */
/* eslint-disable camelcase */
import {
  ClickAwayListener,
  Grid,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  makeStyles,
} from '@material-ui/core'
import React, { useEffect, useRef, useState } from 'react'

import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../../components/hooks/BaseTableComponents'
import {
  dateFormatedFullDate,
  exportFormatedMoney,
} from '../../../../util/utils'

const ItemsTable = ({ items = [] }) => {
  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <StyledTableCellHeader align="left">
              Descrição
            </StyledTableCellHeader>

            <StyledTableCellHeader align="center">
              Data do agendamento
            </StyledTableCellHeader>

            <StyledTableCellHeader align="center">Status</StyledTableCellHeader>

            <StyledTableCellHeader align="right">Total</StyledTableCellHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {items?.map((item, index) => (
            <TableRow key={index} hover>
              <StyledTableCellBody align="left">
                {item?.name}
              </StyledTableCellBody>
              <StyledTableCellBody align="center">
                {item?.attendance_started_at
                  ? dateFormatedFullDate(item?.attendance_started_at)
                  : '-'}
              </StyledTableCellBody>
              <StyledTableCellBody align="center">
                {item?.status?.name}
              </StyledTableCellBody>
              <StyledTableCellBody align="right">
                {exportFormatedMoney(item?.final_value || 0)}
              </StyledTableCellBody>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default ItemsTable
